import request from "root/js/request";

export const getAnalyticsCrossMPProductCostsIncomeDateOzon = async ({
  cabinet_id,
  cabinet_id__in,
  marketplace,
  ...rest
}) => {
  const response = await request({
    url: "/ozon_analytics/income_product_cost/income_dates/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};
